import { ReactNode } from 'react';

import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DescriptionIcon from '@mui/icons-material/Description';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PaymentsIcon from '@mui/icons-material/Payments';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';

const ICON_MAP: Record<string, ReactNode> = {
  School: <SchoolIcon />,
  EventAvailable: <EventAvailableIcon />,
  Payments: <PaymentsIcon />,
  AccountBalance: <AccountBalanceIcon />,
  Person: <PersonIcon />,
  CalendarMonth: <CalendarMonthIcon />,
};

/**
 * Resolves an icon name string to a React icon component.
 * Returns a fallback icon if the name is not recognized.
 */
export function resolveIcon(iconName: string): ReactNode {
  return ICON_MAP[iconName] ?? <DescriptionIcon />;
}
